import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/ai-resume-builder/AIResumeBuilderContent.tsx");
